<div mat-dialog-title>
  <h2>{{"reviews.Report review content" | translate}}</h2>
  <button mat-icon-button (click)="openConfirmDialog()" class="close">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<form [formGroup]="formGroup">
  <mat-dialog-content>
    <div class="mat-dialog-body">
      <div class="fields-group">
        <mat-form-field hideRequiredMarker [class.loading-field]="reasonsLoading">
          <mat-label>{{"wastedFood.Reason" | translate}}</mat-label>
          <mat-select formControlName="reasoneId">
            <mat-option *ngFor="let option of reasons" [value]="option.id">
              {{option.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('reasoneId', 'required')">{{ 'forms.Required' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{"forms.Notes" | translate}}</mat-label>
          <textarea matInput formControlName="notes" maxlength="300"></textarea>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button type="button" (click)="openConfirmDialog()" class="btn-grey">
      {{"forms.Cancel" | translate}}</button>

    <button (click)="saveRecord()" mat-raised-button color="primary"
      [disabled]="loading" [class.loading]="loading">
      {{"forms.Submit" | translate}}
    </button>
  </mat-dialog-actions>
</form>
